"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gift = require("../../store/gift/gift.actions");

var _gift2 = require("../../store/gift/gift.selector");

var _invitationType = require("../../store/gift/invitationType");

var _templates = require("../../store/templates/templates.actions");

var _templates2 = require("../../store/templates/templates.selector");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _shipping = require("../../store/shipping/shipping.actions");

var _shipping2 = require("../../store/shipping");

var _shipping3 = require("../../store/shipping/shipping.types");

var _ManualAddressForm = _interopRequireDefault(require("./ManualAddressForm"));

var _AddressSelectionForm = _interopRequireDefault(require("./AddressSelectionForm"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    actions: {
      padding: spacing(2)
    },
    title: {
      paddingTop: spacing(2)
    },
    buttonIcon: {
      marginRight: spacing(1),
      color: 'inherit'
    },
    knowAddressButton: {
      marginTop: spacing(3),
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none',
      fontWeight: 'normal',
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    findAddressButton: {
      boxShadow: 'none',
      fontWeight: 'normal'
    }
  };
});
var findAddressMock = {
  address_line_1: 'xx',
  address_line_2: 'xx',
  state: 'CA',
  zip: '11111',
  city: 'xx',
  country_id: 1
};

var InvitationTypeAddressFormComponent = function InvitationTypeAddressFormComponent(_ref2) {
  var onClick = _ref2.onClick;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isAddressRequired = (0, _reactRedux.useSelector)(_invitationType.getIsInvitationTypeRequiresAddress);
  var isSaving = (0, _reactRedux.useSelector)(_invitationType.getIsInvitationTypesSaving);
  var invitationTypeId = (0, _reactRedux.useSelector)(_invitationType.getSelectedInvitationTypeId);
  var giftId = (0, _reactRedux.useSelector)(_gift2.getGiftId);
  var defaultTemplate = (0, _reactRedux.useSelector)(_templates2.getDefaultTemplate);
  var recipientName = (0, _reactRedux.useSelector)(_gift2.getGiftRecipientName);
  var isTemplatesLoading = (0, _reactRedux.useSelector)(_templates2.getTemplatesIsLoading);
  var countryId = (0, _reactRedux.useSelector)(_gift2.getGiftRecipientCountryId);
  var isDirectDeliveryMethod = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var isAddressValidated = (0, _reactRedux.useSelector)(_shipping2.getIsValidated);
  var verifiedAddress = (0, _reactRedux.useSelector)(_shipping2.getVerifiedAddress);
  var isSaveDisabled = !invitationTypeId || isSaving || isTemplatesLoading;
  var trackAddressConfirm = (0, _useTrackGiftingFlow.useTrackGiftingFlowRecipientAddressSubmitted)();
  var campaignId = (0, _reactRedux.useSelector)(_gift2.getGiftCampaignId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : campaign.team.id;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFormVisible = _useState2[0],
      setFormVisibility = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      address = _useState4[0],
      setAddress = _useState4[1];

  var _useState5 = (0, _react.useState)(_shipping3.AddressOption.none),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      targetAddress = _useState6[0],
      setTargetAddressInner = _useState6[1];

  var setTargetAddress = (0, _react.useCallback)(function (value) {
    setTargetAddressInner(value);
  }, [setTargetAddressInner]);
  var findAddress = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, findAddressMock), {}, {
      country_id: countryId
    });
  }, [countryId]); // Skip template list step if campaign has a default template

  (0, _react.useEffect)(function () {
    dispatch((0, _templates.loadTemplatesRequest)(giftId));
  }, [dispatch, giftId]);
  (0, _react.useEffect)(function () {
    if (defaultTemplate) {
      dispatch((0, _gift.selectTemplate)(defaultTemplate));
    }
  }, [dispatch, defaultTemplate]);
  /**
   * Hide manual address form when component becomes visible
   */

  (0, _react.useEffect)(function () {
    if (isAddressRequired) {
      setFormVisibility(false);
    }
  }, [isAddressRequired]);
  /**
   * Hide manual address form when invitation type changed.
   */

  (0, _react.useEffect)(function () {
    setFormVisibility(false);
  }, [invitationTypeId]);
  (0, _react.useEffect)(function () {
    if (isDirectDeliveryMethod && !address) {
      dispatch((0, _shipping.resetVerification)());
      dispatch((0, _invitationType.clearErrors)());
      dispatch((0, _shipping.resetErrors)());
    }
  }, [dispatch, isDirectDeliveryMethod, address]);
  /**
   * Fill form by mock when it's hidden.
   */

  (0, _react.useEffect)(function () {
    if (!isFormVisible && !isDirectDeliveryMethod) {
      setAddress(findAddress);
    } else {
      dispatch((0, _shipping.resetVerification)());
      dispatch((0, _invitationType.clearErrors)());
      dispatch((0, _shipping.resetErrors)());
      setAddress({
        address_line_1: '',
        address_line_2: '',
        state: '',
        zip: '',
        city: '',
        country_id: 1
      });
    }
  }, [isDirectDeliveryMethod, isFormVisible, findAddress, setAddress, dispatch]);

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var confirmAddress = (0, _react.useCallback)(function () {
    if (isDirectDeliveryMethod && !isAddressValidated) {
      dispatch(_shipping.validateShipping.pending({
        giftId,
        address: {
          address: address.address_line_1 || '',
          address2: address.address_line_2 || '',
          city: address.city || '',
          zipcode: address.zip || '',
          phone: address.phone || '',
          state: address.stateCode || ''
        }
      }));
    } else {
      var baseAddress = targetAddress === _shipping3.AddressOption.original || !isDirectDeliveryMethod ? _objectSpread(_objectSpread({}, address), {}, {
        phone: address.phone === '' ? null : address.phone
      }) : {
        address_line_1: verifiedAddress.addressLines[0],
        address_line_2: verifiedAddress.addressLines[1] || '',
        city: verifiedAddress.city,
        zip: verifiedAddress.zipcode,
        phone: address.phone === '' ? null : address.phone,
        state: verifiedAddress.stateName,
        stateCode: verifiedAddress.stateCode,
        country_id: 1
      };
      dispatch((0, _invitationType.saveInvitationType)({
        returnAddress: isAddressRequired ? findAddress : null,
        deliveryAddress: isAddressRequired ? baseAddress : null
      }));
    }
  }, [isDirectDeliveryMethod, isAddressValidated, dispatch, giftId, address, targetAddress, verifiedAddress, isAddressRequired, findAddress]);
  var setMethodHandler = (0, _react.useCallback)(function () {
    onClick();
    confirmAddress();

    if (isAddressRequired) {
      trackAddressConfirm(false);
    }

    trackEvent('Gifting flow — clicked set gift invitation', {
      gift_id: giftId,
      invitationId: invitationTypeId,
      team_id: teamId
    });
  }, [onClick, confirmAddress, trackAddressConfirm, trackEvent, invitationTypeId, teamId, giftId, isAddressRequired]);
  var iKnowAddressHandler = (0, _react.useCallback)(function () {
    setFormVisibility(true);
  }, []);
  var findAddressHandler = (0, _react.useCallback)(function () {
    trackAddressConfirm(true);
    confirmAddress();
  }, [confirmAddress, trackAddressConfirm]);

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isAgreed = _useState8[0],
      setIsAgreed = _useState8[1];

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isDirectDeliveryMethod && /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    direction: "down",
    in: !isFormVisible && isAddressRequired,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    p: 3,
    pt: 0
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)('H4-Dark', classes.title),
    pb: 3
  }, "Great choice! What\u2019s ", recipientName, "\u2019s address?"), /*#__PURE__*/_react.default.createElement(_material.Button, {
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    className: classes.findAddressButton,
    onClick: findAddressHandler
  }, "Find ", recipientName, "\u2019s address for me"), /*#__PURE__*/_react.default.createElement(_material.Button, {
    fullWidth: true,
    variant: "contained",
    className: classes.knowAddressButton,
    onClick: iKnowAddressHandler
  }, "I know ", recipientName, "\u2019s address"))), isDirectDeliveryMethod && isAddressValidated && address ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    px: 2
  }, /*#__PURE__*/_react.default.createElement(_AddressSelectionForm.default, {
    originalAddress: address,
    setTargetAddress: setTargetAddress
  })) : /*#__PURE__*/_react.default.createElement(_ManualAddressForm.default, {
    isVisible: isFormVisible || isDirectDeliveryMethod,
    mockAddress: findAddress,
    recipient: recipientName,
    onChange: setAddress
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    direction: "down",
    in: !isAddressRequired || isFormVisible || isDirectDeliveryMethod,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    wrap: "nowrap",
    direction: "row",
    justifyContent: "flex-end",
    className: classes.actions
  }, isDirectDeliveryMethod && isAddressValidated && address && /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: isAgreed,
      onChange: function onChange() {
        return setIsAgreed(!isAgreed);
      }
    }),
    label: /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Label-Input-Active",
      style: {
        lineHeight: '16px'
      }
    }, "By checking this box, you are confirming that you have permission to contact this recipient and that you are compliant with your company\u2019s internal data privacy policies.")
  }), /*#__PURE__*/_react.default.createElement(_material.Button, {
    disabled: isSaveDisabled || isDirectDeliveryMethod && !isAgreed,
    variant: "contained",
    color: "secondary",
    onClick: setMethodHandler,
    style: {
      minWidth: 160
    }
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "arrow-right",
    color: "primary",
    className: classes.buttonIcon
  }), "Set method"))));
};

InvitationTypeAddressFormComponent.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = InvitationTypeAddressFormComponent;
exports.default = _default;